
/**
 * @class
 * Device model
 */
export class Device {

    /**
     * @constructor
     * @param {String} id Device id
     * @param {Object} attibutes Attributes
     * @param {Object} configuration Configuration
     * @param {Object} configurationSignaled Configuration signaled
     */
    constructor(
      id,
      attributes,
      configuration,
      configurationSignaled
    ){ 
      this._id = id
      this._attributes = attributes
      this._configuration = configuration
      this._configurationSignaled = configurationSignaled
    }

    get id(){
      return this._id
    }
    set id(id){
      this._id = id
    }

    get attributes(){
      return this._attributes
    }
    set attributes(attributes){
      this._attributes = attributes
    }

    get configuration(){
      return this._configuration
    }
    set configuration(configuration){
      this._configuration = configuration
    }

    get configurationSignaled(){
        return this._configurationSignaled
    }
    set configurationSignaled(configurationSignaled){
        this._configurationSignaled = configurationSignaled
    }
    
    /**
     * Merge patch device with current device
     */
    merge(patch){
      for(let i in patch.attributes){
        if(!this._attributes) this._attributes = {}
        //this._attributes[i] = patch.attributes[i]
        this._attributes.setCaseInsensProp(i,patch.attributes.getCaseInsensProp(i))
      }
      for(let i in patch.configuration){
        if(!this.configuration) this._configuration = {}
        //this._configuration[i] = patch.configuration[i]
        this._configuration.setCaseInsensProp(i,patch.configuration.getCaseInsensProp(i))
      }
      for(let i in patch.configurationSignaled){
        if(!this._configurationSignaled) this._configurationSignaled = {}
        //this._configurationSignaled[i] = patch.configurationSignaled[i]
        this._configurationSignaled.setCaseInsensProp(i,patch.configurationSignaled.getCaseInsensProp(i))
      }
    }
}

export class DeviceCredentials{

    /**
     * @constructor
     * @param {String} name Credentials label
     * @param {Boolean} isAvailable Creadentials are available
     * @param {Object} credentials Credentials
     */
    constructor(
      name,
      isAvailable,
      credentials
    ){ 
      this._name = name
      this._isAvailable = isAvailable
      this._credentials = credentials
    }

    get name(){
      return this._name
    }
    set name(name){
      this._name = name
    }

    get isAvailable(){
      return this._isAvailable
    }
    set isAvailable(isAvailable){
      this._isAvailable = isAvailable
    }

    get credentials(){
      return this._credentials
    }
    set credentials(credentials){
      this._credentials = credentials
    }
}

export class Command{

  /**
   * @constructor
   * @param {String} name Command name
   * @param {String} description Command description
   * @param {Array} args Command arguments
   */
  constructor(
    name,
    description,
    args
  ){ 
    this._name = name
    this._description = description
    this._args = args
  }

  get name(){
    return this._name
  }

  get description(){
    return this._description
  }

  get args(){
    return this._args
  }
}



